// src/pages/Hotels.tsx
import React, { useEffect, useState } from "react";
import HotelCard from "../components/HotelCard";
import InquiryModal from "../components/InquiryModal";
import { Hotel, getHotels } from "../components/api/hotel";
import "./Hotels.css"; // ✅ CSS for layout and styling

const Hotels: React.FC = () => {
  const [hotels, setHotels] = useState<Hotel[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [inquiryHotel, setInquiryHotel] = useState<Hotel | null>(null);
  const [selectedCity, setSelectedCity] = useState<string>("All");

  useEffect(() => {
    const fetchHotels = async () => {
      try {
        const data = await getHotels();
        setHotels(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHotels();
  }, []);

  // Normalize city names and get unique list
  const cities = [
    "All",
    ...Array.from(
      new Set(hotels.map((h) => h.location.trim().toLowerCase()))
    ).map((city) =>
      city
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    ),
  ];

  // Filter hotels by selected city
  const filteredHotels =
    selectedCity === "All"
      ? hotels
      : hotels.filter(
          (hotel) =>
            hotel.location.trim().toLowerCase() ===
            selectedCity.trim().toLowerCase()
        );

  if (loading) return <p>Loading hotels...</p>;
  if (error) return <p className="error">Error: {error}</p>;

  return (
    <div className="hotels-page">
      <h1>Hotels</h1>

      {/* City Filter Buttons */}
      <div className="city-filters">
        {cities.map((city) => (
          <button
            key={city}
            onClick={() => setSelectedCity(city)}
            className={selectedCity === city ? "active" : ""}
          >
            {city}
          </button>
        ))}
      </div>

      {/* Hotels Grid */}
      <section className="hotels-grid">
        {filteredHotels.map((hotel) => (
          <HotelCard
            key={hotel.id}
            hotel={hotel}
            onInquiry={() => setInquiryHotel(hotel)}
          />
        ))}
      </section>

      {/* Inquiry Modal */}
      {inquiryHotel && (
        <InquiryModal
          show={true}
          onClose={() => setInquiryHotel(null)}
          inquiryData={{
            type: "Hotel",
            name: "",
            email: "",
            phone: "",
            from: undefined,
            to: undefined,
            date: undefined,
            nameOfItem: inquiryHotel.name,
             tripType: "", // ✅ Add this
          }}
        />
      )}
    </div>
  );
};

export default Hotels;
